export default __webpack_public_path__ + "static/media/icon-steto.66781491.svg";